import { useState } from 'react';

export const useToggle = (
  defaultValue = false,
): [boolean, () => void, (param: boolean) => void] => {
  const [value, setValue] = useState(defaultValue);
  const toggle = (): void => setValue(!value);

  return [value, toggle, setValue];
};
